__turbopack_context__.v({
  "button-wrapper": "virtual-tour-button-module-scss-module__LcWFfG__button-wrapper",
});
